import { Button, Rating, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import classNames from 'classnames';
import React, {
  FC,
  Fragment,
  createRef,
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Link } from 'react-router-dom';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage'
import { Basket } from '../../Modules/Basket';
import { Favorite } from '../../Modules/Favorite';
import { CatalogItemsSort } from '../../api/def_client_api';
import { Util } from '../../common/util/util';
import { useAppDispatch } from '../../hooks/redux';
import { useBasket } from '../../hooks/useBasket';
import { useFavorite } from '../../hooks/useFavorite';
import { useUser } from '../../hooks/useUser';
import { BasketCatalogItemI } from '../../shared/types/basket';
import { CustomButton } from '../Button';
import { Icon } from '../Icon';

interface ICatalogItemProps {
  item: BasketCatalogItemI;
  className?: string;
  screen: 'desktop' | 'mobile';
}
export const CatalogItem: FC<ICatalogItemProps> = memo(
  ({ item, className, screen }) => {
    const dispatch = useAppDispatch();
    const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');
    const { favorites, favoriteQuantity } = useFavorite();
    const { items: basketItems, cards_id: addToBasketIds } = useBasket();
    const { session_token, loggedIn } = useUser();
    const [openAlertEmail, setOpenAlertEmail] = useState(false);

    const handleCloseAlertEmail = () => setOpenAlertEmail(false);
    const isAvailability =
      item.availability === 'availability' && item.availability_count >= 1;
    //Проверяет, активный Id или нет
    const isAddToBasket = (item_id: number) =>
      Util.isActiveId(basketItems, item_id);
    const isAddToFavorite = (item_id: number) =>
      Util.isActiveId(favorites, item_id);
    // Добавить в избранное
    const add_to_favorite = async (item: any) => {
      await Favorite.toggleFavorite(favorites, item, dispatch);
    };
    // Добавить в корзину
    const add_to_cart = async (item: BasketCatalogItemI) => {
      if (
        item.availability === CatalogItemsSort.No ||
        item.availability_count < 1
      ) {
        return setOpenAlertEmail(true);
      }
      await Basket.add_to_cart(item, basketItems, dispatch);

      //Вызов синхронизации корзины с сервером, если залогинен
      if (loggedIn) {
        //Синхронизация при добавлении товара в корзину
        await Basket.basketSynchronization(dispatch);
      }
    };
    const mobileScreen = useMediaQuery('(max-width:900px)');

    const [newParametrsText, setNewParametrsText] = useState('');
    /*  const refComponent = createRef<any>();
  useEffect(() => {
    const current = refComponent.current;
    if (current) {
      const height = current.getBoundingClientRect().height;
      setOffsetHeight(height);
      //Если высота будет больше 200px, то ставим многоточие
      if (height >= 57 && screen !== 'mobile') {
        const newPageParametrs = item?.title.slice(0, 98) + '...';
        setNewParametrsText(newPageParametrs);
      }
    }
  }, [refComponent]);*/

    //Найден ли элемент в корзине
    let isItemExistBasket = false;
    if (item) {
      let catalog_items = basketItems;
      isItemExistBasket = Basket.isItemExistBasket(catalog_items, item.id);
    }
    return (
      <Fragment>
        {screen === 'desktop' && (
          <Fragment>
            <li
              key={item.id}
              className={classNames('catalog-card', className, screen)}
            >
              <div
                className={classNames(
                  'catalog-card__wrapper',
                  className,
                  screen
                )}
              >
                <div
                  onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
                >
                  <Link
                    key={item.id}
                    to={'/items/' + item.slug}
                    className={classNames(
                      'catalog-card__wrapper_link',
                      className,
                      screen
                    )}
                  ></Link>
                </div>
                <div
                  className={classNames(
                    'catalog-card__image',
                    className,
                    screen
                  )}
                >
                  <div>
                    {item.img ? (
                      <img src={item.img} alt="img" />
                    ) : (
                      <Icon
                        variant={
                          className === 'grid' || className === 'favorite'
                            ? 'empty'
                            : 'emptyMin'
                        }
                      />
                    )}
                  </div>
                </div>
                <div
                  className={classNames('catalog-card__description', screen)}
                >
                  {/*<li className="catalog-card__reviews">
                <Icon variant="starGray" className="icon_review" />
                Нет отзывов
              </li>*/}

                  {className === 'grid' && (
                    <div
                      className={classNames(
                        'catalog-card__price',
                        className,
                        screen
                      )}
                    >
                      {item.price_kopecks / 100} <span>₽</span>
                    </div>
                  )}
                  {className === 'favorite' && (
                    <div
                      className={classNames(
                        'catalog-card__price',
                        className,
                        screen
                      )}
                    >
                      {item.price_kopecks / 100} <span>₽</span>
                    </div>
                  )}
                  <div
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: 'auto' })
                    }
                  >
                    <Link
                      to={'/items/' + item.slug}
                      className={classNames(
                        'catalog-card__top',
                        className,
                        screen
                      )}
                    >
                      <div
                        className={classNames(
                          'catalog-card__title',
                          className,

                          {
                            ['mobile']: mobileScreen,
                          }
                        )}
                      >
                        <div>
                          {newParametrsText
                            ? newParametrsText
                            : Util.textByRegex(item.title)}
                        </div>
                      </div>
                      {className === 'list' && (
                        <div
                          className={classNames(
                            'catalog-card__price',
                            className,
                            screen
                          )}
                        >
                          {item.price_kopecks / 100} <span>₽</span>
                        </div>
                      )}
                    </Link>
                  </div>
                  <div
                    className={classNames(
                      'catalog-card__bottom',
                      className,
                      screen
                    )}
                  >
                    <ul
                      className={classNames(
                        'catalog-card__right-bottom',
                        className,
                        screen
                      )}
                    >
                      <div
                        style={{
                          display: 'flex',
                          columnGap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <div className="interaction__stars">
                          <Rating
                            size="large"
                            readOnly
                            defaultValue={0}
                            value={Number(item.stars_avg)}
                          />
                        </div>
                        {/*{catalog_item?.id}*/}
                        {item.reviews_comments_count}
                      </div>
                      <div
                        className={classNames('catalog-card__block', className)}
                      >
                        <li
                          className="catalog-card__like"
                          onClick={() => add_to_favorite(item)}
                        >
                          {isAddToFavorite(item.id) ? (
                            <Icon variant="heartOrangeOutlined" />
                          ) : (
                            <Icon variant="heartGrayOutlined" />
                          )}
                        </li>
                        <li
                          className={classNames(
                            'catalog-card__button',
                            className,
                            screen
                          )}
                        >
                          {isAvailability ? (
                            <>
                              {isAddToBasket(item.id) ? (
                                <CustomButton
                                  variant="outlined"
                                  className={
                                    isAddToBasket(item.id)
                                      ? 'basket_active'
                                      : ''
                                  }
                                >
                                  <Link to="/basket">В корзине</Link>
                                </CustomButton>
                              ) : (
                                <CustomButton
                                  variant="outlined"
                                  onClick={(event: any) => {
                                    add_to_cart(item);
                                  }}
                                  className={
                                    isAddToBasket(item.id)
                                      ? 'basket_active'
                                      : ''
                                  }
                                >
                                  В корзину
                                </CustomButton>
                              )}
                            </>
                          ) : (
                            <CustomButton
                              variant="outlined"
                              className="disabled catalogItem"
                            >
                              <p>Уведомить</p>
                            </CustomButton>
                          )}
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </li>

            <Dialog
              open={openAlertEmail}
              onClose={handleCloseAlertEmail}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {'Данный товар не доступен или нет желаемого кол-ва'}
              </DialogTitle>

              <DialogActions>
                <Button onClick={handleCloseAlertEmail} autoFocus>
                  ок
                </Button>
              </DialogActions>
            </Dialog>
          </Fragment>
        )}
        {screen === 'mobile' && (
          <Fragment>
            <li
              key={item.id}
              className={classNames('catalog-card', className, screen)}
            >
              <div
                className={classNames(
                  'catalog-card__wrapper',
                  className,
                  screen
                )}
              >
                <Link
                  to={'/items/' + item.slug}
                  className={classNames(
                    'catalog-card__image',
                    className,
                    screen
                  )}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
                >
                  <div>
                    {item.img ? (
                      <img src={item.img} alt="img" />
                    ) : (
                      <Icon
                        variant={
                          className === 'grid' || className === 'favorite'
                            ? 'empty'
                            : 'emptyMin'
                        }
                      />
                    )}
                  </div>
                </Link>
                <div
                  className={classNames(
                    'catalog-card__description',
                    className,
                    screen
                  )}
                >
                  {/*<li className="catalog-card__reviews">
                <Icon variant="starGray" className="icon_review" />
                Нет отзывов
              </li>*/}
                  <div
                    className={classNames(
                      'catalog-card__container',
                      className,
                      screen
                    )}
                  >
                    {className === 'grid' && (
                      <div
                        className={classNames(
                          'catalog-card__price',
                          className,
                          screen
                        )}
                      >
                        {item.price_kopecks / 100} <span>₽</span>
                      </div>
                    )}
                    {className === 'favorite' && (
                      <div
                        className={classNames(
                          'catalog-card__price',
                          className,
                          screen
                        )}
                      >
                        {item.price_kopecks / 100} <span>₽</span>
                      </div>
                    )}
                    <div
                      className={classNames(
                        'catalog-card__top',
                        className,
                        screen
                      )}
                    >
                      <div
                        className={classNames(
                          'catalog-card__title',
                          className,
                          screen
                        )}
                        /*onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}*/
                      >
                        <Link
                          to={'/items/' + item.slug}
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: 'auto' })
                          }
                        >
                          {newParametrsText
                            ? newParametrsText
                            : Util.textByRegex(item.title)}
                        </Link>
                      </div>
                      {className === 'list' && (
                        <div
                          className={classNames(
                            'catalog-card__price',
                            className,
                            screen
                          )}
                        >
                          {item.price_kopecks / 100} <span>₽</span>
                        </div>
                      )}
                    </div>
                  </div>
                  {/*<div style={{ display: 'flex', columnGap: '8px' }}>
                      <div className="interaction__stars">
                        <Icon variant="starGray" />
                        <Icon variant="starGray" />
                        <Icon variant="starGray" />
                        <Icon variant="starGray" />
                        <Icon variant="starGray" />
                      </div>
                      {catalog_item?.id}0
                    </div>*/}
                  <div
                    className={classNames(
                      'catalog-card__block',
                      className,
                      screen
                    )}
                  >
                    <li
                      className={classNames(
                        'catalog-card__like',
                        className,
                        screen
                      )}
                      onClick={() => add_to_favorite(item)}
                    >
                      {isAddToFavorite(item.id) ? (
                        <Icon variant="heartOrangeOutlined" />
                      ) : (
                        <Icon variant="heartGrayOutlined" />
                      )}
                    </li>
                    <li
                      className={classNames(
                        'catalog-card__button',
                        className,
                        screen
                      )}
                    >
                      {isItemExistBasket ? (
                        <CustomButton
                          variant="outlined"
                          className={
                            isAddToBasket(item.id) ? 'basket_active' : ''
                          }
                        >
                          <Link to="/basket">В корзине</Link>
                        </CustomButton>
                      ) : (
                        <CustomButton
                          variant="outlined"
                          onClick={(event: any) => {
                            add_to_cart(item);
                          }}
                          className={
                            isAddToBasket(item.id) ? 'basket_active' : ''
                          }
                        >
                          В корзину
                        </CustomButton>
                      )}
                    </li>
                  </div>
                </div>
              </div>
              <span
                className={classNames(
                  'catalog-card__divider',
                  className,
                  screen
                )}
              ></span>
              <div
                className={classNames(
                  'catalog-card__bottom',
                  className,
                  screen
                )}
              >
                <Icon variant="shop" />
                <span
                  className={classNames(
                    'catalog-card__bottom__title',
                    className,
                    screen
                  )}
                >
                  {item.vendor.title}
                </span>
              </div>
            </li>

            <Dialog
              open={openAlertEmail}
              onClose={handleCloseAlertEmail}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {'Данный товар не доступен или нет желаемого кол-ва'}
              </DialogTitle>

              <DialogActions>
                <Button onClick={handleCloseAlertEmail} autoFocus>
                  ок
                </Button>
              </DialogActions>
            </Dialog>
          </Fragment>
        )}
      </Fragment>
    );
  }
);
